module.exports = __webpack_public_path__ + "img/icon_benefit_02.1760084d.svg";